interface TestimonialCardProps {
  rating: number;
  review: string;
  name: string;
  role: string;
}

export function TestimonialCard({
  rating,
  review,
  name,
  role,
}: TestimonialCardProps) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;

  return (
    <div
      className="flex flex-col justify-between items-start self-stretch mobile-customers-card transition-all duration-300 cursor-pointer border border-[rgba(255,255,255,0.06)] bg-[rgba(255,255,255,0.02)] backdrop-blur-[4px] hover:border-[rgba(118,188,232,0.20)] hover:bg-[rgba(118,188,232,0.03)] hover:backdrop-blur-[4px]"
      style={{
        width: '360px',
        minHeight: '220px',
        padding: '28px 28px 24px 28px',
        borderRadius: '16px',
      }}
    >
      <div className="self-stretch inline-flex justify-start items-start gap-[3px]">
        {[...Array(fullStars)].map((_, i) => (
          <img
            key={i}
            src="/icons/star.svg"
            alt="star"
            className="w-[18px] h-[18px]"
          />
        ))}
        {hasHalfStar && (
          <img
            src="/icons/star.svg"
            alt="star"
            className="w-[18px] h-[18px]"
            style={{ opacity: 0.35 }}
          />
        )}
        {[...Array(5 - Math.ceil(rating))].map((_, i) => (
          <img
            key={i}
            src="/icons/star.svg"
            alt="star"
            className="w-[18px] h-[18px]"
            style={{ opacity: 0.35 }}
          />
        ))}
      </div>
      <div className="flex flex-col flex-1 mt-6">
        <div
          className="text-sm font-normal font-['Inter'] mobile-customers-review"
          style={{ color: 'rgba(255, 255, 255, 0.6)', lineHeight: '24px' }}
        >
          "{review}"
        </div>
      </div>
      <div
        className="self-stretch pt-5 border-t inline-flex justify-start items-center gap-3"
        style={{ borderColor: 'rgba(255, 255, 255, 0.06)' }}
      >
        <div
          className="size-10 rounded-[20px] outline outline-2 outline-offset-[-2px] inline-flex flex-col justify-center items-start overflow-hidden"
          style={{ outlineColor: 'rgba(118, 188, 232, 0.25)' }}
        >
          <img
            className="self-stretch flex-1 relative"
            src="https://placehold.co/36x36"
          />
        </div>
        <div className="min-w-24 inline-flex flex-col justify-start items-start">
          <div className="self-stretch flex flex-col justify-start items-start">
            <div
              className="justify-center text-sm font-semibold font-['Inter'] mobile-customers-name"
              style={{ color: '#FAFAFA' }}
            >
              {name}
            </div>
          </div>
          <div className="self-stretch pt-0.5 flex flex-col justify-start items-start">
            <div className="self-stretch flex flex-col justify-start items-start">
              <div
                className="self-stretch justify-center text-xs font-normal font-['Inter'] mobile-customers-role"
                style={{ color: 'rgba(255, 255, 255, 0.35)' }}
              >
                {role}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
